/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsFeaturedCollection = {
  init: function($section) {
    // Add settings from schema to current object
    window.PXUTheme.jsFeaturedCollection = $.extend(this, window.PXUTheme.getSectionData($section));

    if (this.collection_layout == 'slider') {
      this.createSlider('.slider-gallery--desktop');
    }

    if (this.collection_layout_mobile == 'slider') {
      this.createSlider('.slider-gallery--mobile');
    }
    
    // Always initialize swatch handlers for the section
    if (window.PXUTheme.swatchHandler) {
      window.PXUTheme.swatchHandler.init($section);
    }
  },
  createSlider: function(el) {
    const slider = $(el);
    const isMobile = window.innerWidth <= 798;
    const productsPerSlide = parseInt(slider.attr('data-products-per-slide')) || 3;

    $(slider).flickity({
      lazyLoad: 2,
      freeScroll: false,
      imagesLoaded: true,
      draggable: true,
      cellAlign: isMobile ? 'left' : 'center',
      wrapAround: true,
      pageDots: false,
      contain: isMobile ? true : false,
      prevNextButtons: this.products_limit > this.products_per ? true : false,
      initialIndex: 0,
      arrowShape: arrowShape,
    });

    // Set cell width based on products per slide
    const flkty = slider.data('flickity');
    if (flkty) {
      const viewportWidth = flkty.size.width;
      let cellWidth;
      
      if (isMobile) {
        // Mobile: 1 product per slide with margins
        cellWidth = viewportWidth - 20; // 20px total margin
      } else {
        // Desktop: based on productsPerSlide setting with margins
        cellWidth = (viewportWidth / productsPerSlide) - 20; // 20px for margins
        //console.log('Desktop cellWidth:', cellWidth, 'Viewport width:', viewportWidth, 'Products per slide:', productsPerSlide);  
      }
      
      slider.find('.gallery-cell').css('width', cellWidth + 'px');
      flkty.resize();
    }

    // Recalculate cell width on window resize
    $(window).on('resize', function() {
      const flkty = slider.data('flickity');
      if (flkty) {
        const isMobileNow = window.innerWidth <= 798;
        const viewportWidth = flkty.size.width;
        let cellWidth;
        
        if (isMobileNow) {
          cellWidth = viewportWidth - 20;
          flkty.options.cellAlign = 'left';
          flkty.options.contain = true;
        } else {
          cellWidth = (viewportWidth / productsPerSlide) - 20;
          flkty.options.cellAlign = 'center';
          flkty.options.contain = false;
        }
        
        slider.find('.gallery-cell').css('width', cellWidth + 'px');
        flkty.resize();
      }
    });

    $(slider).on('settle.flickity', () => $(slider).flickity('resize'));
  },
  unload: function($section) {
    let $slider = $section.find('.flickity-enabled');
    $slider.flickity('destroy');
  }
}

/******/ })()
;